import Vue from 'vue'


const utils = new Vue({
    methods: {
        parseDate(timestamp) {
            const date = new Date(timestamp);
            return date.toLocaleDateString('da-DK', {
                month: "short",
                day: "numeric",
                year: "numeric"
            }) + ", \n" + date.toLocaleTimeString('da-DK', {hour: '2-digit', minute: '2-digit'});
        },
        parseUntilDate(timestamp) {
            if (timestamp === 0) {
                return "N/A";
            } else if (timestamp === -1) {
                return "Permanent";
            }
            return this.parseDate(timestamp);
        },
        convertDateToInput(date) {
            let month = date.getMonth() + 1;
            let day = date.getDate();
            return date.getFullYear() + "-" + (month < 9 ? '0' + month : month) + "-" + (day < 9 ? '0' + day : day);
        },
        convertTimeToInput(date) {
            let hours = date.getHours();
            let mins = date.getMinutes();
            let secs = date.getSeconds();
            return (hours < 9 ? '0' + hours : hours) + ":" + (mins < 9 ? '0' + mins : mins)
        },
        isExpired(removed_by_name, expire) {
            if (removed_by_name === '#expired') {
                return 1;
            } else if (removed_by_name !== null && removed_by_name !== undefined) {
                return 2;
            } else if (expire !== -1 && new Date() > new Date(expire)) {
                return 1;
            }
            return 0;
        },
        getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
            let results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        },
        getPageType(name) {
            let n = name.split("_");
            return {category: n[0], type: n[1]}
        }
    }
});

export default {
    install: function (Vue) {
        Vue.prototype.$utils = utils
    }
}
